<template>
  <div class="content-wrapper">
    <!-- <layout></layout> -->
    <crumbs :trail="'投放明细'" :subTrail="` > ${operateType}`" :href="'http://baidu.com'"></crumbs>
    <div class="banxin">
      <div class="content-wrapper-body">
        <h2 class="page-title">{{operateType}}</h2>
        <div class="basic-info">
          <block :blockName="[{name: '基本信息', id: 0, isActive: true}]"></block>
          <div class="form-group">
            <div class="form-inline">
              <div class="form-item require">
                <label class="label">广告ID/名称:</label>
                <el-select v-model="formData.adid" filterable placeholder="请选择">
                  <el-option
                    v-for="item in adList"
                    :key="item.Id"
                    :label="item.value"
                    :value="item.Id">
                  </el-option>
                </el-select>
              </div>
              <div class="form-item require">
                <label class="label">计划名称:</label>
                <el-input v-model="formData.planName" placeholder="限15字以内" maxlength="15"></el-input>
              </div>
              <div class="form-item require">
                <label class="label">投放链接:</label>
                <el-input v-model="formData.putonLink" placeholder="请输入链接"></el-input>
              </div>
            </div>
            <div class="form-inline">
              <div class="form-item require">
                <label class="label">投放形式:</label>
                <el-select v-model="formData.putonType" placeholder="请选择">
                  <el-option
                    v-for="item in putonTypes"
                    :key="item.PutOnTypeId"
                    :label="item.PutOnTypeName"
                    :value="item.PutOnTypeId">
                  </el-option>
                </el-select>
              </div>
              <div class="form-item require">
                <label class="label">广告标签:</label>
                <el-input v-model="tagName" placeholder="选择标签" @focus="tagTrigger = true"></el-input>
              </div>
              <div class="form-item">
                <label class="label">曝光排序:</label>
                <el-radio v-model="formData.exposureSort" :label="0">默认</el-radio>
                <el-radio v-model="formData.exposureSort" :label="1">手动排序</el-radio>
                <el-input
                  type="text"
                  placeholder="输入数字"
                  style="width: 111px; margin-left: 7px"
                  v-model="formData.orderNum"
                  :disabled="formData.exposureSort !== 1">
                </el-input>
              </div>
            </div>
            <div class="form-inline">
              <div class="form-item money-item">
                <label class="label">计划日预算:</label>
                <el-input v-model="formData.planDayBudget" placeholder="请输入"></el-input>
                <span class="money-icon">￥</span>
              </div>
              <div class="form-item require">
                <label class="label">广告类型:</label>
                <el-radio v-model="formData.adType" :label="0">广告</el-radio>
                <el-radio v-model="formData.adType" :label="1">奖品</el-radio>
              </div>
              <div class="form-item require">
                <label class="label">投放日期:</label>
                <el-date-picker
                  v-model="formData.putonDate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div>
            <div class="form-inline">
                <div class="form-item require">
                  <label class="label">计费类型:</label>
                  <el-select v-model="formData.accountType" placeholder="请选择" style="width: 187px; margin-right: 12px;">
                    <el-option label="CPC" :value="0" :disabled="cannotChange == 'cpa'"></el-option>
                    <el-option label="CPA" :value="1" :disabled="cannotChange == 'cpc'"></el-option>
                  </el-select>
                  <el-checkbox v-model="formData.linkJs">接入JS</el-checkbox>
                </div>
                <div class="form-item">
                  <label class="label">开启状态:</label>
                  <el-switch
                  v-model="formData.openS"
                  inactive-color="#ccc"
                  active-color="#5798d7">
                </el-switch>
              </div>
              <div style="width: 366px;"></div>
            </div>
          </div>
          <div class="form-group" style="border-top: 1px dashed #dee2e6">
            <div class="form-inline" style="display: flex; justify-content: flex-start;">
              <div class="form-item left require" style="width: 516px;">
                <label class="label">广告素材</label>
                <div class="content-wrapper strategy">
                  <multiMateial :materials="materials" :materialsMin="materialsMin" @addMaterial="addMaterial" @closeMaterialW="closeMaterialW"></multiMateial>
                </div>
              </div>
              <div class="form-item right" style="width: 716px; margin-left: 34px;">
                <label class="label">广告详情</label>
                <div class="content-wrapper rich-text">
                  <div class="components-container">
                    <!-- <button @click="getUEContent()">获取内容</button> -->
                    <!-- <button @click="getUEContentTxt()">获取无文本内容</button> -->
                    <div class="editor-container">
                      <UE :defaultMsg="formData.defaultMsg" :config="config" :id="ue1" ref="ue"></UE>
                    </div>
                  </div>
                  <div class="important-declare">
                    <textarea cols="30" rows="10" v-model="formData.ImportantStatement" placeholder="重要声明"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="stratergy-group">
          <block :blockName="strategyList" @changeS="changeStrategy"></block>
          <span class="add-strategy" @click="openStrategyWindow">新增策略<i class="el-icon-circle-plus-outline"></i></span>
          <div class="form-group">
            <div class="form-inline">
              <div class="form-item require">
                <label class="label">操作系统:</label>
                <el-checkbox-group v-model="strategyActive.OS">
                  <el-checkbox label="ios"></el-checkbox>
                  <el-checkbox label="android"></el-checkbox>
                  <el-checkbox label="其他"></el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="form-item require">
                <label class="label">投放地域:</label>
                <el-radio v-model="strategyActive.AreaRange" :label="0">全部地域</el-radio>
                <el-radio v-model="strategyActive.AreaRange" :label="1" ref="partArea">部分地域</el-radio>
              </div>
              <div class="form-item">
                <label class="label" style="width: 90px">策略开启状态:</label>
                <el-switch
                v-model="strategyActive.openS"
                inactive-color="#ccc"
                active-color="#5798d7"></el-switch>
              </div>
            </div>
            <div class="form-inline" style="justify-content: flex-start;">
              <div class="form-item require" style="width: 1267px">
                <label class="label" style="width: 100px">小时限流设置</label>
                <div class="limit-config">
                  <div class="data-inline data-header">
                    <div class="tHeader item1">
                      <!-- <span class="btnWeek" @mouseenter="weekStatus=true" @mouseleave="weekStatus=false" > -->
                      <span class="btnWeek">
                        星期
                        <!-- {{ curWeekDay }} <i class="el-icon-arrow-down" style="font-size: 17px"></i> -->
                        <transition name="weekGroup">
                          <div class="week-group" v-show="weekStatus">
                            <span :class="['week-item', {'active':weekIndx === 1}]" @click="filterWeek(1)">周一</span>
                            <span :class="['week-item', {'active':weekIndx === 2}]" @click="filterWeek(2)">周二</span>
                            <span :class="['week-item', {'active':weekIndx === 3}]" @click="filterWeek(3)">周三</span>
                            <span :class="['week-item', {'active':weekIndx === 4}]" @click="filterWeek(4)">周四</span>
                            <span :class="['week-item', {'active':weekIndx === 5}]" @click="filterWeek(5)">周五</span>
                            <span :class="['week-item', {'active':weekIndx === 6}]" @click="filterWeek(6)">周六</span>
                            <span :class="['week-item', {'active':weekIndx === 7}]" @click="filterWeek(7)">周日</span>
                            <span :class="['week-item', {'active':weekIndx === 0}]" @click="filterWeek(0)">全部</span>
                          </div>
                        </transition>
                      </span>
                    </div>
                    <div class="tHeader item2">投放时间段</div>
                    <div class="tHeader item3">限流类型</div>
                    <div :class="['tHeader', 'item4', {'skew': strategyActive.HourLimits && strategyActive.HourLimits.length > 6}]">数值</div>
                    <div :class="['tHeader', 'item5', {'skew': strategyActive.HourLimits && strategyActive.HourLimits.length > 6}]">操作</div>
                  </div>
                  <div class="data-body">
                    <div class="data-inline" v-for="(item, index) in strategyActive.HourLimits" :key="item.BusinessId">
                      <div class="tBody item1">
                        <el-button
                          size="small"
                          v-for="(sItem, $index) in selectDay(item)"
                          :key="$index"
                          :class="[{'active': sItem.selected}]"
                          @click="weekStatusSwitch($event, item, $index)">{{ sItem.name }}</el-button>
                      </div>
                      <div class="tBody item2">
                        <el-select v-model="item[0].BeginHour" @change="timeSelect(item)" placeholder="请选择" style="width: 80px">
                          <el-option
                            v-for="hItem in hour_24"
                            :key="hItem.value"
                            :label="hItem.label"
                            :value="hItem.value"
                            :disabled="hItem.value >= item[0].EndHour">
                          </el-option>
                        </el-select> 至
                        <el-select v-model="item[0].EndHour" @change="timeSelect(item)" placeholder="请选择" style="width: 80px">
                          <el-option
                            v-for="hItem in hour_24"
                            :key="hItem.value"
                            :label="hItem.label"
                            :value="hItem.value"
                            :disabled="hItem.value <= item[0].BeginHour">
                          </el-option>
                        </el-select>
                      </div>
                      <div class="tBody item3">
                        <el-select v-model="item[0].LimitType" placeholder="请选择" style="max-width: 100%;">
                          <el-option
                            v-for="item in options1"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </div>
                      <div class="tBody item4">
                        <el-input placeholder="请输入" style="width: 100%;" v-model="item[0].LimitQty"></el-input>
                      </div>
                      <div class="tBody item5">
                        <i class="el-icon-circle-plus-outline" @click="addHourLimit(item, index)"></i>
                        <i class="el-icon-remove-outline" @click="removeHourLimit(item, index)"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-inline">
              <div class="form-item require">
                <label class="label">广告位设置:</label>
                <el-radio v-model="strategyActive.SourceRange" :label="0">全部</el-radio>
                <el-radio v-model="strategyActive.SourceRange" :label="1">定投/屏蔽</el-radio>
              </div>
              <div class="form-item require money-item">
                <label class="label">计费单价:</label>
                <el-input placeholder="输入单价" v-model="strategyActive.AccessPrice"></el-input>
                <span class="money-icon">￥</span>
              </div>
              <div class="form-item money-item">
                <label class="label">策略日预算:</label>
                <el-input v-model="strategyActive.LimitAmount" placeholder="输入日预算"></el-input>
                <span class="money-icon">￥</span>
              </div>
            </div>
          </div>
        </div>
        <div class="ads-config" v-show="strategyActive.SourceRange === 1">
          <div class="ads-config-item direct">
            <div class="leftTopTag">定投广告位</div>
            <div class="search-part">
              <el-input
              placeholder="输入ID或名称"
              style="width: 224px; margin-right: 32px;"
              v-model="pKeyWords"
              @keyup.enter.native="filterPAds"></el-input>
              <el-button type="primary" size="small" @click="filterPAds">搜索</el-button>
              <el-button type="primary" size="small" @click="openAdsW(0)">选择</el-button>
              <!-- <el-button type="primary" size="small">导入</el-button> -->
            </div>
            <div class="list-part">
              <div class="list-header">
                <span class="list-item item1">广告位ID</span>
                <span class="list-item item2">广告位名称</span>
                <span class="list-item item3">预算</span>
                <span :class="['list-item', 'item4', {'skew': pList.length > 7}]">操作</span>
              </div>
              <div class="list-body">
                <div class="list-tr" v-for="item in pList" :key="item.id">
                  <span class="list-item item1">{{ item.id }}</span>
                  <span class="list-item item2" :title="item.name">{{ item.name }}</span>
                  <span class="list-item item3" style="color: #5798d7" @click="configBudget(item)">{{ item.money }}<i class="el-icon-edit" v-show="!(item.money > 0)"></i></span>
                  <span class="list-item item4"><i class="el-icon-remove-outline" @click="deletePutonAds(item.id)"></i></span>
                </div>
              </div>
            </div>
          </div>
          <div class="ads-config-item sheild">
            <div class="leftTopTag">屏蔽广告位</div>
            <div class="search-part">
              <el-input
              placeholder="输入ID或名称"
              style="width: 224px; margin-right: 32px;"
              v-model="sKeyWords"
              @keyup.enter.native="filterSAds"></el-input>
              <el-button type="primary" size="small" @click="filterSAds">搜索</el-button>
              <el-button type="primary" size="small" @click="openAdsW(1)">选择</el-button>
              <!-- <el-button type="primary" size="small">导入</el-button> -->
            </div>
            <div class="list-part">
              <div class="list-header">
                <span class="list-item item1">广告位ID</span>
                <span class="list-item item2">广告位名称</span>
                <span :class="['list-item', 'item4', {'skew' : sList.length > 7}]">操作</span>
                <!-- <span class="list-item" style="width: 0"></span> -->
              </div>
              <div class="list-body">
                <div class="list-tr" v-for="item in sList" :key="item.id">
                  <span class="list-item item1">{{ item.id }}</span>
                  <span class="list-item item2" :title="item.name">{{ item.name }}</span>
                  <span class="list-item item4"><i class="el-icon-remove-outline" @click="deleteShieldAds(item.id)"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="btn-group">
          <el-button type="default">返回</el-button>
          <el-button type="primary" @click="addData">确定</el-button>
        </div>
      </div>
    </div>

    <el-dialog title="新增策略" :visible.sync="strategyTrigger" class="addStrategy" @open="openStrategyW">
      <el-form>
        <el-form-item label="策略类型" :label-width="formLabelWidth">
          <el-radio v-model="addStrtegy.strategyType" :label="1">新增</el-radio>
          <el-radio v-model="addStrtegy.strategyType" :label="2">复制</el-radio>
          <el-select placeholder="请选择策略" style="margin-left: 30px"  v-model="addStrtegy.strategyItem" :disabled="addStrtegy.strategyType === 1">
            <el-option v-for="item in strategyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="新策略名称" :label-width="formLabelWidth">
          <el-input placeholder="请输入（限6字）" maxlength="6" style="width: 373px" v-model="addStrtegy.strategyName" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addStrategy(0)">取 消</el-button>
        <el-button type="primary" @click="addStrategy(1)">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="投放地域" :visible.sync="areaTrigger" class="areaWindow" @open="openAreaW" @close="closeAreaW(0)">
      <div class="putonArea">
        <div class="region" v-for="aItem in areaList" :key="aItem.Areacode">
          <label class="check-item">
            <input type="checkbox" :checked="aItem.selected" @change="clickAreaItem(aItem)">
            <span class="area-name" :title="aItem.AreaName">{{ aItem.AreaName }}</span>
          </label>
          <div class="provinces-group">
            <div :class="['provinces', {'mouseon': activeAreaCode === pItem.Areacode}]" v-for="pItem in aItem.subProvinces" :key="pItem.Areacode" @mouseenter="showSubCities(pItem)" @mouseleave="hideSubCities" >
              <label class="check-item">
                <input type="checkbox" :checked="pItem.selected" @change="clickProvinceItem(aItem, pItem)">
                <span class="area-name" :title="pItem.AreaName">{{ pItem.AreaName }}</span>
              </label>
              <div class="cities-group">
                <div class="cities" v-for="cItem in pItem.subCities" :key="cItem.Areacode">
                  <label class="check-item">
                    <input type="checkbox" :checked="cItem.selected" @change="clickCityItem(aItem, pItem, cItem)">
                    <span class="area-name" :title="cItem.AreaName">{{ cItem.AreaName }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAreaW(0)">取 消</el-button>
        <el-button type="primary" @click="closeAreaW(1)">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="广告标签" :visible.sync="tagTrigger" class="tagWindow" @close="closeTagW(0)" >
      <div>
        <div class="industry-tag-header">
          <div class="tab-btn">
            <span :class="['tab-btn-item', 'tab-btn-ind', {'active': tagType === 0}]" @click="switchTag(0)">行业</span>
            <span :class="['tab-btn-item', 'tab-btn-type', {'active': tagType === 1}]" @click="switchTag(1)">品类</span>
          </div>
        </div>
        <div class="industry-tag-body">
          <div
            :class="['selection-group', {'mouseon': tagIndex === index}]"
            v-for="(item, index) in tagDataActive"
            :key="item.LabelId"
            @mouseenter="showSubTag(index)"
            @mouseleave="tagIndex = -1">
            <label class="checkbox-item industry-trunk">
              <input
                type="checkbox"
                :id="item.LabelId"
                :name="item.LabelName"
                :checked="tagArr.indexOf(String(item.LabelId)) > -1"
                @change="pTagStatusSwitch(item)">
              <span>{{ item.LabelName }}</span>
            </label>
            <div class="industry-branch">
              <label
                class="checkbox-item"
                v-for="tItem in item.subTags"
                :key="tItem.LabelId">
                <input
                  @change="subTagStatusSwitch(item, tItem)"
                  type="checkbox"
                  :id="tItem.LabelId"
                  :name="tItem.LabelName"
                  :checked="tagArr.indexOf(String(tItem.LabelId)) > -1">
                <span>{{ tItem.LabelName }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeTagW(0)">取 消</el-button>
        <el-button type="primary" @click="closeTagW(1)">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑预算" :visible.sync="budgetTrigger" >
      <el-form>
        <el-form-item label="输入预算" :label-width="formLabelWidth">
          <el-input placeholder="请输入" style="width: 373px" v-model="budgetConfig.money" maxlength="9"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="budgetTrigger = false">取 消</el-button>
        <el-button type="primary" @click="setBudget">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 广告位弹窗 -->
    <transition name="adsW">
      <div class="ads-sheild" v-if="adsWS">
        <div class="ads-frame">
          <div class="frame-header">
            <h4>选择广告位</h4>
            <div class="search-box">
              <i class="icon el-icon-search"></i>
              <input type="text" id="search-frame" v-model="mediaKeyWord" @input="searchMedia">
            </div>
            <span class="el-icon-close closeFrame" @click="closeAdsW(0)"></span>
          </div>
          <div class="frame-body">
            <ul class="clearfloat media-list" id="sourceList">
              <li v-for="item in adsList" :key="item.SourceId">
                <input :class="['btn', 'btn-default', 'media-item', {'selected': item.isSelected}]"
                  :title="item.SourceName"
                  type="button"
                  :value="item.SourceName"
                  :sourceid="item.SourceId"
                  @click="switchAdsStatus(item)">
              </li>
            </ul>
          </div>
          <div class="frame-footer">
            <div class="btn-box">
              <el-button type="default" @click="closeAdsW(0)">取消</el-button>
              <el-button type="primary" @click="closeAdsW(1)">确认</el-button>
            </div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import layout from "../public/layout/layout";
import crumbs from "../public/crumbs/crumbs";
import block from "../public/edit-plan-sub/block";
import multiMateial from "../public/edit-plan-sub/multiMateial";
import UE from "../public/edit-plan-sub/ue.vue";
import qs from 'qs';

export default {
  data() {
    return {
      adList: [],
      timeout:  null,
      Data: {},
      isEdit: false,
      cannotChange: '',
      tagData: {
        industries: [],
        type: []
      },
      tagList: [],
      tagDataActive: [],
      tagType: 0,
      tagIndex: -1,
      tagName: '',
      tagArr: [],
      tagNameArr: [],
      areaData: '',
      areaList: [],
      activeAreaCode: -1,
      putonAreaIdArr: [],
      operateType: '添加计划',
      options1: [
        {
          value: 0,
          label: "预算"
        },
        {
          value: 1,
          label: "每小时预算"
        },
        {
          value: 2,
          label: "曝光"
        },
        {
          value: 3,
          label: "每小时曝光"
        }
      ],
      putonTypes: [],
      formData: {},
      config: {
        initialFrameWidth: null,
        initialFrameHeight: 177
      },
      ue1: "ue1",
      strategyTrigger: false,
      formLabelWidth: "120px",
      adsWS: false,
      allAdsList: [],
      adsList: [],
      putOnSourceIds: [],
      putOnSourceIds2: [],
      shieldSourceId: '',
      shieldSourceId2: '',
      putonAds: [],
      shieldAds: [],
      sList: [],
      pList: [],
      pKeyWords: '',
      sKeyWords: '',
      isPutOn: false,
      Ads: [],
      budgetTrigger: false,
      areaTrigger: false,
      tagTrigger: false,
      budgetConfig: {},
      strategyList: [],
      strategyActive: {},
      materials: [],
      materialsMin: [],
      mediaKeyWord: '',
      addStrtegy: {
        strategyType: 1,
        strategyItem: 1,
        strategyName: ''
      },
      strategyOrder: 0,
      hour_24: [
        {
          value: 0,
          label: '0时'
        },
        {
          value: 1,
          label: '1时'
        },
        {
          value: 2,
          label: '2时'
        },
        {
          value: 3,
          label: '3时'
        },
        {
          value: 4,
          label: '4时'
        },
        {
          value: 5,
          label: '5时'
        },
        {
          value: 6,
          label: '6时'
        },
        {
          value: 7,
          label: '7时'
        },
        {
          value: 8,
          label: '8时'
        },
        {
          value: 9,
          label: '9时'
        },
        {
          value: 10,
          label: '10时'
        },
        {
          value:11,
          label: '11时'
        },
        {
          value:12,
          label: '12时'
        },
        {
          value: 13,
          label: '13时'
        },
        {
          value: 14,
          label: '14时'
        },
        {
          value: 15,
          label: '15时'
        },
        {
          value: 16,
          label: '16时'
        },
        {
          value: 17,
          label: '17时'
        },
        {
          value: 18,
          label: '18时'
        },
        {
          value: 19,
          label: '19时'
        },
        {
          value: 20,
          label: '20时'
        },
        {
          value: 21,
          label: '21时'
        },
        {
          value: 22,
          label: '22时'
        },
        {
          value: 23,
          label: '23时'
        },
        {
          value: 24,
          label: '24时'
        }
      ],
      weekIndx: 0,
      weekStatus: false,
      curWeekDay: '全部'
    }
  },
  methods: {
    // 选择天
    selectDay (item) {
      let days = [{name: '周一', selected: false},{name: '周二',selected: false},{name: '周三',selected: false},{name: '周四',selected: false},{name: '周五',selected: false},{name: '周六',selected: false},{name: '周日',selected: false}]
      for (let i = 0; i < item.length; i++) {
        days[item[i].Day - 1].selected = true
      }
      return days
    },
    // 修改时间同步
    timeSelect (days) {
      for (let i = 1; i < days.length; i++) {
        for (let key in days[0]) {
          if (key !== 'Day') {
            days[i][key] = days[0][key]
          }
        }
      }
    },
    // 请求数据
    getData (id, adid, tag) {
      if (id === 0) {   // id是0 新建
        this.Data = {
          AdId: adid == 0 ? '' : Number(adid),
          AdTaskName: "",
          AdrLink: "",
          PutOnTypeId: '',
          LabelIds: "",
          OrderType: 0,
          OrderNum: 0,
          LimitAmount: '',
          AwardType: 0,
          ValidityDateStart: "",
          ValidityDateEnd: "",
          ChargeType: '',
          JSFlag: 0,
          IsComplete: 0,
          GraphicText: "",
          ImportantStatement: "",
          Materials: [],
          Strategys: [
            {
              AdTaskName: '默认策略',
              PutOnId: 0,
              OperatingSystem: "",
              AreaRange: 0,
              PutOnAreaId: "",
              IsComplete: 0,
              SourceRange: 0,
              AccessPrice: '',
              LimitAmount: '',
              HourLimits: [
                [
                  {
                    Day: 1,
                    BeginHour: 0,
                    EndHour: 24,
                    LimitType: 0,
                    LimitQty: 0
                  }
                ]
              ],
              SourceLimits: [],
              ShieldSourceId: ","
            }
          ]
        }
        this.formData = {
          adid: this.Data.AdId,
          planName: this.Data.AdTaskName,
          putonLink: this.Data.AdrLink,
          putonType: this.Data.PutOnTypeId,
          putonid: 0,
          adTag: this.Data.LabelIds,
          exposureSort: this.Data.OrderType,
          orderNum: this.Data.OrderNum,
          planDayBudget: this.Data.LimitAmount,
          adType: this.Data.AwardType,
          putonDate: [this.Data.ValidityDateStart, this.Data.ValidityDateEnd],
          accountType: this.Data.ChargeType,
          openS: this.Data.IsComplete === 0 ? false : true,
          linkJs: this.Data.JSFlag === 0 ? false : true,
          ImportantStatement: this.Data.ImportantStatement,
          defaultMsg: this.Data.GraphicText
        }
        if (this.isEdit) {
          if (this.formData.accountType = 0) {
            this.cannotChange = 'cpc'
          } else {
            this.cannotChange = 'cpa'
          }
        }
        this.getAllActivities()
        this.strategyList = []
        this.reorgStrategy()
        this.materials = this.Data.Materials
        this.updateMaterialState()
        this.getAreaData()
        this.getTagData()
        this.getPutonType()
      } else {
        let params = {}
        if (tag == 1) {  // id不是0，tag是1  代表复制
          params = {
            copyid: id
          }
        } else {   // id不是0， tag是0 代表编辑
          params = {
            putOnId: id 
          }
        }
        this.$http.get('/iad_puton/AddPutOn', {params}).then(res => {
          if (!res.data) {
            this.$message.error('数据获取失败')
            return
          }
          if (res.data.data.Strategys.length === 0) {
            const data = {
              AccessPrice: '',
              AreaRange: 0,
              HourLimits: '[]',
              IsComplete: 0,
              LimitAmount: '',
              AdTaskName: this.addStrtegy.strategyName,
              OS: 3,
              OperatingSystem: ',h5,',
              PutOnAreaId: '',
              PutOnId: 0,
              ShieldSourceId: ',',
              SourceLimits: '[]',
              SourceRange: 0,
              openS: false
            }
            res.data.data.Strategys.push(data)
          }
          res.data.data.Strategys.forEach((item, index) => {
            item.HourLimits = JSON.parse(item.HourLimits)
            if (item.HourLimits.length === 0) {
              item.HourLimits.push([{
                Day: 1,
                BeginHour: 0,
                EndHour: 24,
                LimitType: 0,
                LimitQty: 0
              }])
            }
            item.SourceLimits = JSON.parse(item.SourceLimits)
          })
          this.Data = res.data.data
          this.formData = {
            adid: this.Data.AdId,
            putonid: this.Data.PutOnId,
            planName: this.Data.AdTaskName,
            putonLink: this.Data.AdrLink,
            putonType: this.Data.PutOnTypeId,
            adTag: this.Data.LabelIds,
            exposureSort: this.Data.OrderType,
            orderNum: this.Data.OrderNum,
            planDayBudget: this.Data.LimitAmount,
            adType: this.Data.AwardType,
            putonDate: [this.Data.ValidityDateStart, this.Data.ValidityDateEnd],
            accountType: this.Data.ChargeType,
            openS: this.Data.IsComplete === 0 ? false : true,
            linkJs: this.Data.JSFlag === 0 ? false : true,
            ImportantStatement: this.Data.ImportantStatement,
            defaultMsg: this.Data.GraphicText
          }
          this.getAllActivities()
          this.strategyList = []
          this.reorgStrategy()
          this.materials = this.Data.Materials
          this.updateMaterialState()
          this.getAreaData()
          this.getTagData()
        })
      }
    },
    // 获取广告列表
    getAdList () {
      this.$http.get('/IAD_AdsManage/GetIADAdSelectList').then(res => {
        this.adList = res.data
      })
    },
    // 获取地域数据
    getAreaData () {
      this.$http.get('/iad_puton/GetAreaList').then(res => {
        this.areaData = res.data
        this.areaData.forEach((item, index) => {
          if (item.AreaLevel === 2) {
            item.subProvinces = []
            this.areaList.push(item)
          }
        })
        this.areaData.forEach((item, index) => {
          this.areaList.forEach((aItem, aIndex) => {
            if (item.ParentAreaCode === aItem.Areacode) {
              item.subCities = []
              aItem.subProvinces.unshift(item)
            }
          })
        })
        this.areaData.forEach((item, index) => {
          this.areaList.forEach((aItem, aIndex) => {
            aItem.subProvinces.forEach((pItem, pIndex) => {
              if (item.ParentAreaCode === pItem.Areacode && pItem.Areacode != 0) {
                pItem.subCities.unshift(item)
              }
            })
          })
        })
      })
    },
    // 显示子城市列表
    showSubCities (data) {
      if (data.subCities.length > 0) {
        this.activeAreaCode = data.Areacode
      }
    },
    // 隐藏子城市列表
    hideSubCities () {
      this.activeAreaCode = -1
    },
    // 打开地域弹窗
    openAreaW () {
      const putonIds = this.strategyActive.PutOnAreaId
      this.areaList.forEach((aItem, aIndex) => {
        aItem.subProvinces.forEach((pItem, pIndex) => {
          pItem.subCities.forEach((cItem, cIndex) => {
            if (putonIds.indexOf(cItem.Areacode) > -1) {
              cItem.selected = true
              pItem.selected = true
              aItem.selected = true
            }
          })
        })
      })

      // 这个操作是为了地域弹窗数据重排
      this.areaList = JSON.parse(JSON.stringify(this.areaList))
    },
    // 点击城市选项
    clickCityItem (area, province, city) {
      if (city.selected) {
        city.selected = false
        let ptag = false
        let atag = false
        province.subCities.forEach((item, index) => {
          if (item.selected) {
            ptag = true
          }
        })
        province.selected = ptag
        area.subProvinces.forEach((item, index) => {
          if (item.selected) {
            atag = true
          }
        })
        area.selected = atag
      } else {
        city.selected = true
        province.selected = true
        area.selected = true
      }
      this.areaList = JSON.parse(JSON.stringify(this.areaList))
    },
    // 点击省选项
    clickProvinceItem (area, province) {
      if (province.selected) {
        province.selected = false
        province.subCities.forEach((item, index) => {
          item.selected = false
        })
        let tag = false
        area.subProvinces.forEach((item, index) => {
          if (item.selected) {
            tag = true
          }
        })
        area.selected = tag
      } else {
        province.selected = true
        area.selected = true
        province.subCities.forEach((item, index) => {
          item.selected = true
        })
      }
      this.areaList = JSON.parse(JSON.stringify(this.areaList))
    },
    // 点击地区选项
    clickAreaItem (area) {
      if (area.selected) {
        area.selected = false
        area.subProvinces.forEach((pItem, pIndex) => {
          pItem.selected = false
          pItem.subCities.forEach((cItem, cIndex) => {
            cItem.selected = false
          })
        })
      } else {
        area.selected = true
        area.subProvinces.forEach((pItem, pIndex) => {
          pItem.selected = true
          pItem.subCities.forEach((cItem, cIndex) => {
            cItem.selected = true
          })
        })
      }
      this.areaList = JSON.parse(JSON.stringify(this.areaList))
    },
    // 关闭地域弹窗
    closeAreaW (tag) {
      const index = this.strategyOrder
      this.areaTrigger = false
      if (tag === 1) {
        let currentStrategyArr = []
        this.areaList.forEach((aItem, aIndex) => {
          aItem.selected = false
          aItem.subProvinces.forEach((pItem, pIndex) => {
            pItem.selected = false
            pItem.subCities.forEach((cItem, cIndex) => {
              if (cItem.selected) {
                currentStrategyArr.push(cItem.Areacode)
              }
              cItem.selected = false
            })
          })
        })
        this.Data.Strategys[index].PutOnAreaId = ',' + currentStrategyArr.join(',') + ','
        this.strategyActive.PutOnAreaId = this.Data.Strategys[index].PutOnAreaId
      } else {
        this.areaList.forEach((aItem, aIndex) => {
          aItem.selected = false
          aItem.subProvinces.forEach((pItem, pIndex) => {
            pItem.selected = false
            pItem.subCities.forEach((cItem, cIndex) => {
              cItem.selected = false
            })
          })
        })
      }
    },
    // 获取标签数据
    getTagData () {
      this.$http.get('/iad_puton/GetLabelList').then(res => {
        this.tagList = res.data
        this.tagList.forEach((item, index) => {
          if (item.ParentLabelId === 0 && item.LabelType === 0) {
            item.subTags = []
            this.tagData.industries.push(item)
          } else if (item.ParentLabelId === 0 && item.LabelType === 1) {
            item.subTags = []
            this.tagData.type.push(item)
          }
        })
        this.tagList.forEach((item, index) => {
          if (item.ParentLabelId !== 0 && item.LabelType === 0) {
            this.tagData.industries.forEach((iItem, iIndex) => {
              if (iItem.LabelId === item.ParentLabelId) {
                iItem.subTags.push(item)
              }
            })
          } else if (item.ParentLabelId !== 0 && item.LabelType === 1) {
            this.tagData.type.forEach((tItem, tIndex) => {
              if (tItem.LabelId === item.ParentLabelId) {
                tItem.subTags.push(item)
              }
            })
          }
        })
        this.switchTag()
        this.filterTagNameById()
      })
    },
    // 切换标签
    switchTag (t = 0) {
      this.tagType = t
      if (t === 0) {
        this.tagDataActive = this.tagData.industries
      } else {
        this.tagDataActive = this.tagData.type
      }
    },
    // 通过id筛选标签名称
    filterTagNameById () {
      this.tagArr = this.formData.adTag.split(',')
      this.tagNameArr = []
      this.tagArr.pop()
      this.tagArr.shift()
      this.tagList.some((item, index) => {
        this.tagArr.forEach((dItem, dIndex) => {
          if (item.LabelId == dItem) {
            this.tagNameArr.push(item.LabelName)
          }
        })
      })
      this.tagName = this.tagNameArr.join('，')
    },
    // 鼠标悬停 显示子标签
    showSubTag (index) {
      if (this.tagDataActive[index].subTags.length > 0) {
        this.tagIndex = index
      }
    },
    // 子标签状态切换
    subTagStatusSwitch (parent, sub) {
      const id1 = String(parent.LabelId)
      const id2 = String(sub.LabelId)
      if (this.tagArr.indexOf(id2) > -1) {
        this.tagArr.splice(this.tagArr.indexOf(id2), 1)
        let flag = false
        parent.subTags.some((item, index) => {
          if (this.tagArr.indexOf(String(item.LabelId)) > -1) {
            flag = true
            return true
          }
        })
        if (!flag) {
          this.tagArr.splice(this.tagArr.indexOf(id1), 1)
        }
      } else {
        this.tagArr.push(id2)
        if (this.tagArr.indexOf(id1) === -1) {
          this.tagArr.push(id1)
        }
      }
    },
    // 父标签状态切换
    pTagStatusSwitch (data) {
      const i = this.tagArr.indexOf(String(data.LabelId))
      if (i > -1) {
        this.tagArr.splice(i, 1)
        data.subTags.forEach((item, index) => {
          const j = this.tagArr.indexOf(String(item.LabelId))
          if (j > -1) {
            this.tagArr.splice(j, 1)
          }
        })
      } else {
        this.tagArr.push(String(data.LabelId))
        data.subTags.forEach((item, index) => {
          this.tagArr.push(String(item.LabelId))
        })
      }
    },
    // 关闭标签弹窗
    closeTagW (tag) {
      this.tagTrigger = false
      if (tag === 1) {
        this.formData.adTag = ',' + this.tagArr.join(',') + ','
        this.filterTagNameById()
      } else {
        this.filterTagNameById()
      }
    },
    // 更新策略状态
    updateMaterialState () {
      let opened = []
      let unopened = []
      this.materials.forEach((item, index) => {
        item.oldState = item.OpenState === 0 ? false : true
        item.isNew = false
        item.oldBtnName = item.BtnName
        item.oldDesc = item.Desc
        item.oldName = item.Name
        if (item.oldState) {
          opened.push(item)
        } else{
          unopened.push(item)
        }
      })
      this.materials = opened.concat(unopened)
    },
    // 添加素材
    addMaterial (newMaterial) {
      this.materials.unshift({
        MaterialId: 0,
        Name: "",
        Desc: "",
        BtnName: "",
        BannerSrc: newMaterial.imgurl,
        OpenState: 0,
        AddDate: newMaterial.AddDate,
        isNew: true
      })
    },
    // 关闭素材弹窗
    closeMaterialW (tag) {
      if (tag === 0) {
        let count = 0
        this.materials.forEach((item, index) => {
          if (item.oldState) {
            item.OpenState = 1
            item.openState = true
          } else {
            item.OpenState = 0
            item.openState = false
          }
          item.BtnName = item.oldBtnName
          item.Desc = item.oldDesc
          item.Name = item.oldName
          if (item.isNew) {
            count++
          }
        })
        this.materials.splice(0, count)
      } else {
        this.updateMaterialState()
      }
    },
    // 获取投放形式列表
    getPutonType () {
      this.$http.get('/iad_puton/GetPutOnTypeList').then(res => {
        this.putonTypes = res.data
      })
    },
    // 组织定投数据
    orgPutonAds () {
      this.putonAds = []
      if (typeof this.putOnSourceIds == 'string') {
        this.putOnSourceIds = JSON.parse(this.putOnSourceIds)
      }
      this.allAdsList.forEach((item, index) => {
        this.putOnSourceIds.some((pItem, pIndex) => {
          if (pItem.SourceId == item.SourceId) {
            this.putonAds.push({
              id: item.SourceId,
              name: item.SourceName,
              money: pItem.LimitAmount
            })
            return true
          }
        })
      })
      this.filterPAds()
    },
    // 组织屏蔽数据
    orgShieldAds () {
      this.shieldAds = []
      this.allAdsList.forEach((item, index) => {
        if (this.shieldSourceId.indexOf(item.SourceId) > -1) {
          this.shieldAds.push({
            id: item.SourceId,
            name: item.SourceName
          })
        }
      })
      this.filterSAds()
    },
    // 获取广告位列表
    getAllActivities () {
      const index = this.strategyOrder
      this.$http.post('/Iad_CustomerTemplate/GetMediaList').then(res => {
        this.allAdsList = res.data
        if (typeof this.Data.Strategys[index].SourceLimits === 'string') {
          this.putOnSourceIds = JSON.parse(this.Data.Strategys[index].SourceLimits)
          if (typeof this.putOnSourceIds === 'string') {
            this.putOnSourceIds = JSON.parse(this.putOnSourceIds)
          } else {
            this.putOnSourceIds = this.Data.Strategys[index].SourceLimits
          }
        } else {
          this.putOnSourceIds = this.Data.Strategys[index].SourceLimits
        }
        this.putOnSourceIds2 = JSON.parse(JSON.stringify(this.putOnSourceIds))
        this.shieldSourceId2 = this.shieldSourceId = this.Data.Strategys[index].ShieldSourceId
        this.orgPutonAds()
        this.orgShieldAds()
        this.adsList = JSON.parse(JSON.stringify(this.allAdsList))
      })
    },
    // 整合广告位状态
    combineAdsStatus () {
      this.adsList.forEach(item => {
        item.isSelected = false
      })
      if (this.isPutOn) {
        this.adsList.forEach((item, index) => {
          this.putOnSourceIds.forEach((pItem, pIndex) => {
            if (pItem.SourceId == item.SourceId) {
              item.isSelected = true
            }
          })
        })
      } else {
        this.adsList.forEach((item, index) => {
          if (this.shieldSourceId.indexOf(item.SourceId) > -1) {
            item.isSelected = true
          }
        })
      }
      this.adsList = JSON.parse(JSON.stringify(this.adsList))
    },
    // 筛选活动列表
    searchMedia () {
      this.adsList = []
      this.allAdsList.forEach((item, index) => {
        if(String(item.SourceId).indexOf(this.mediaKeyWord) > -1 || item.SourceName.indexOf(this.mediaKeyWord) > -1) {
          this.adsList.push(item)
        }
      })
      this.combineAdsStatus()
    },
    // 切换广告位状态
    switchAdsStatus (ads) {
      let isSelected = false
      let i = 0
      if (this.isPutOn) {
        this.putOnSourceIds.forEach((item, index) => {
          if (item.SourceId == ads.SourceId) {
            isSelected = true
            i = index
          }
        })
        if (isSelected) {
          this.putOnSourceIds.splice(i ,1)
        } else {
          this.putOnSourceIds.push({
            SourceId: ads.SourceId,
            LimitAmount: 0
          })
        }
      } else {
        var list = this.shieldSourceId.split(',')
        list.pop()
        list.shift()
        if (list.indexOf(String(ads.SourceId)) > -1) {
          isSelected = true
          i = list.indexOf(String(ads.SourceId))
        }
        if (isSelected) {
          list.splice(i ,1)
        } else {
          list.push(String(ads.SourceId))
        }
        this.shieldSourceId = ',' + list.join(',') + ','
      }
      this.combineAdsStatus()
    },
    // 关闭广告位弹窗
    closeAdsW (tag) {
      const index = this.strategyOrder
      this.adsWS = false
      this.mediaKeyWord = ''
      this.adsList = JSON.parse(JSON.stringify(this.allAdsList))
      if (tag === 0) {
        this.putOnSourceIds = JSON.parse(JSON.stringify(this.putOnSourceIds2))
        this.shieldSourceId = this.shieldSourceId2
        this.Data.Strategys[index].ShieldSourceId = this.shieldSourceId2
        this.Data.Strategys[index].SourceLimits = JSON.parse(JSON.stringify(this.putOnSourceIds2))
      } else {
        this.putOnSourceIds2 = JSON.parse(JSON.stringify(this.putOnSourceIds))
        this.shieldSourceId2 = this.shieldSourceId
        this.Data.Strategys[index].ShieldSourceId = this.shieldSourceId
        this.Data.Strategys[index].SourceLimits = JSON.parse(JSON.stringify(this.putOnSourceIds))
      }
      let sArr = this.shieldSourceId.split(',')   // 屏蔽广告位ID数组
      sArr.pop()
      sArr.shift()
      let dArr = []   // 这个数组记录需要删除的 定投或者屏 蔽数据
      this.putOnSourceIds.forEach((pItem, pIndex) => {
        sArr.some((sItem, sIndex) => {
          if (pItem.SourceId == sItem) {
            dArr.push(pItem.SourceId)
            return true
          }
        })
      })
      if (this.isPutOn) {
        dArr.forEach(item => {
          this.deleteShieldAds(item)
        })
      } else {
        dArr.forEach(item => {
          this.deletePutonAds(item)
        })
      }
      this.orgPutonAds()
      this.orgShieldAds()
    },
    // 打开广告位弹窗
    openAdsW (tag) {
      this.adsWS = true
      this.isPutOn = tag === 0 ? true : false
      this.combineAdsStatus()
    },
    // 编辑预算
    configBudget (ads) {
      this.budgetConfig = JSON.parse(JSON.stringify(ads))
      this.budgetTrigger = true
    },
    // 设置预算
    setBudget () {
      const index = this.strategyOrder
      if (this.budgetConfig.money > 0 && /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(this.budgetConfig.money)) {
        this.putonAds.forEach((item, index) => {
          if (item.id === this.budgetConfig.id) {
            item.money = this.budgetConfig.money
            return true
          }
        })
        this.putOnSourceIds.some((item, index) => {
          if (item.SourceId === this.budgetConfig.id) {
            item.LimitAmount = this.budgetConfig.money
            return true
          }
        })
        this.budgetTrigger = false
        this.Data.Strategys[index].SourceLimits = this.putOnSourceIds
      } else {
        this.$message.error('请输入有效的金额')
      }
    },
    // 筛选定投广告位
    filterPAds () {
      const key = this.pKeyWords
      const list = []
      this.putonAds.forEach((item, index) => {
        if (String(item.id).indexOf(key) > -1 || item.name.indexOf(key) > -1) {
          list.push(item)
        }
      })
      this.pList = list
    },
    // 筛选屏蔽广告位
    filterSAds () {
      const key = this.sKeyWords
      const list = []
      this.shieldAds.forEach((item, index) => {
        if (String(item.id).indexOf(key) > -1 || item.name.indexOf(key) > -1) {
          list.push(item)
        }
      })
      this.sList = list
    },
    // 删除定投广告位
    deletePutonAds (id) {
      const index = this.strategyOrder
      this.isPutOn = true
      this.putonAds.forEach((item, index) => {
        if (item.id == id) {
          this.putonAds.splice(index, 1)
        }
      })
      this.putOnSourceIds.forEach((item, index) => {
        if (item.SourceId == id) {
          this.putOnSourceIds.splice(index, 1)
        }
      })
      this.putOnSourceIds2 = JSON.parse(JSON.stringify(this.putOnSourceIds))
      this.Data.Strategys[index].putOnSourceIds = JSON.parse(JSON.stringify(this.putOnSourceIds))
      this.combineAdsStatus()
      this.filterPAds()
    },
    // 删除屏蔽广告位
    deleteShieldAds (id) {
      const index = this.strategyOrder
      this.isPutOn = false
      this.shieldAds.forEach((item, index) => {
        if (item.id == id) {
          this.shieldAds.splice(index, 1)
        }
      })
      let str = this.shieldSourceId
      let arr = str.split(',')
      arr.forEach((item, index) => {
        if (item == id) {
          arr.splice(index, 1)
        }
      })
      this.shieldSourceId = this.shieldSourceId2 = arr.join(',')
      this.Data.Strategys[index].ShieldSourceId = this.shieldSourceId
      this.combineAdsStatus()
      this.filterSAds()
    },
    // 获取富文本内容
    getUEContent() {
      return this.$refs.ue.getUEContent(); // 调用子组件方法
    },
    // 获取纯文本内容
    getUEContentTxt() {
      let content = this.$refs.ue.getUEContentTxt(); // 调用子组件方法
      this.$notify({
        title: "获取成功，可在控制台查看！",
        message: content,
        type: "success"
      });
      console.log(content);
    },
    // 新增策略
    openStrategyWindow () {
      if (this.strategyList.length >= 8) {
        this.$message.error('单个计划最多可以有8个策略')
        return
      }
      this.strategyTrigger = true
    },
    // 切换策略
    changeStrategy (index) {
      this.strategyList.forEach((item, index) => {
        item.isActive = false
      })

      this.strategyList[index].isActive = true
      this.strategyOrder = index
      this.reorgStrategy()
      this.getAllActivities()
    },
    // 重组策略数据
    reorgStrategy () {
      const index = this.strategyOrder
      this.strategyActive = {}
      this.strategyActive = {
        AccessPrice: this.Data.Strategys[index].AccessPrice,
        AreaRange: this.Data.Strategys[index].AreaRange,
        HourLimits: this.Data.Strategys[index].HourLimits,
        IsComplete: this.Data.Strategys[index].IsComplete,
        LimitAmount: this.Data.Strategys[index].LimitAmount,
        AdTaskName: this.Data.Strategys[index].AdTaskName,
        OS: [],
        OperatingSystem: this.Data.Strategys[index].OperatingSystem,
        PutOnAreaId: this.Data.Strategys[index].PutOnAreaId,
        PutOnId: this.Data.Strategys[index].PutOnId,
        ShieldSourceId: this.Data.Strategys[index].ShieldSourceId,
        SourceLimits: this.Data.Strategys[index].SourceLimits,
        SourceRange: this.Data.Strategys[index].SourceRange,
        hourL: [],
        openS: false
      }
      this.strategyActive.openS = this.strategyActive.IsComplete === 0 ? false : true
      if (this.strategyActive.OperatingSystem.indexOf('ios') > -1) {
        this.strategyActive.OS.push('ios')
      }
      if (this.strategyActive.OperatingSystem.indexOf('android') > -1) {
        this.strategyActive.OS.push('android')
      }
      if (this.strategyActive.OperatingSystem.indexOf('h5') > -1) {
        this.strategyActive.OS.push('其他')
      }
      this.strategyActive.HourLimits.forEach((item, index) => {
        const data = JSON.parse(JSON.stringify(item[0]))
        data.weeksArr = [
          {
            id: 1,
            name: '周一',
            selected: false
          },
          {
            id: 2,
            name: '周二',
            selected: false
          },
          {
            id: 3,
            name: '周三',
            selected: false
          },
          {
            id: 4,
            name: '周四',
            selected: false
          },
          {
            id: 5,
            name: '周五',
            selected: false
          },
          {
            id: 6,
            name: '周六',
            selected: false
          },
          {
            id: 7,
            name: '周日',
            selected: false
          }
        ]

        item.forEach((sItem, sIndex) => {
          data.weeksArr[sItem.Day - 1].selected = true
        })
      })
    },
    // 找重复天
    findRepeatDay (data, day) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].Day === day + 1) {
          return {index: i}
        }
      }
    },
    // 限流日状态切换
    weekStatusSwitch (ev, data, index) {
      // 切换当前选中状态 添加删除天数据
      let currentDay = this.findRepeatDay(data, index)
      if (currentDay) {
        if (data.length > 1) {
          this.$delete(data, currentDay.index)
        } else {
          this.$message({
            message: `必须有一个`,
            type: 'warning'
          });
        }
      } else {
        data.push(Object.assign({}, data[0], {Day: index + 1}))
      }
      // 对比时间段有没有冲突
      this.checkLimitTime()
    },
    // 添加限流数据
    addHourLimit (data, index) {
      // 对比时间段有没有冲突
      if (this.checkLimitTime()) {
        return
      }
      const copyData = {
        Day: 1,
        BeginHour: 0,
        EndHour: 24,
        LimitQty: 0,
        LimitType: 0
      }
      this.strategyActive.HourLimits.push([copyData])
    },
    // 集合取交集
    intersect (arr) {
      let result = []
      let obj = {};
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < arr[i].length; j++) {
          let str = arr[i][j];
          if (!obj[str]) {
            obj[str] = 1;
          }
          else {
            result.push(str)
          }
        }
      }
      if (result.length) {
        // console.log('\n\n\n\n\n\n\n\n\n重复天')
        console.log(arr)
      }
      return result;
    },
    // 检测限流时间
    checkLimitTime (index, hourLimitList) {
      const ind = this.strategyOrder
      let days = {}
      // 找每天的所有时间段
      // console.log(this.strategyActive.HourLimits)
      for (let i = 0, hourLimitList = this.strategyActive.HourLimits; i < hourLimitList.length; i++) {
        for (let j = 0; j < hourLimitList[i].length; j++) {
          let timeSlot = hourLimitList[i][j]
          // 如果没有空间 创建一个空间
          days[timeSlot.Day] || (days[timeSlot.Day] = [])
          // 时间区间
          let times = []
          // 填充开始时间到小于结束时间的时间点
          for (let k = timeSlot.BeginHour; k < timeSlot.EndHour; k++) {
            times.push(k)
          }
          days[timeSlot.Day].push(times)
        }
      }
      // 对比每天所有时间段有没有交叉
      for (let key in days) {
        let repeatTime = this.intersect(days[key])
        if (repeatTime.length) {
          this.$message.error(`周${key}时间段重复`)
          return true
        }
      }
    },
    // 删除限流数据
    removeHourLimit (data, index) {
      if (this.strategyActive.HourLimits.length > 1) {
        this.strategyActive.HourLimits.splice(index, 1)
      } else {
        this.$message({
          message: '抱歉，最后一条限流数据不能删除',
          type: 'warning'
        });
      }
    },
    // 添加策略
    addStrategy (tag) {
      if (tag === 1) {
        if (this.addStrtegy.strategyName.trim() === '') {
          this.$message.error('新策略名称不可为空')
          return
        }
        for(var i = 0; i < this.Data.Strategys.length; i++){
          let item = this.Data.Strategys[i]
          if (item.AdTaskName.trim() === this.addStrtegy.strategyName.trim()) {
            this.$message.error('策略名称已经存在，请重新编辑')
            return
          }
        }
        if (this.addStrtegy.strategyType == 1) {
          const data = {
            AccessPrice: '',
            AreaRange: 0,
            HourLimits: [
              [
                {
                  BeginHour: 0,
                  Day: 1,
                  EndHour: 24,
                  LimitQty: 0,
                  LimitType: 0
                }
              ]
            ],
            IsComplete: 0,
            LimitAmount: '',
            AdTaskName: this.addStrtegy.strategyName,
            OS: '',
            OperatingSystem: '',
            PutOnAreaId: '',
            PutOnId: 0,
            ShieldSourceId: ',',
            SourceLimits: [],
            SourceRange: 0,
            openS: false
          }
          this.Data.Strategys.push(data)
        } else {
          const data = JSON.parse(JSON.stringify(this.Data.Strategys[this.addStrtegy.strategyItem]))
          data.AdTaskName = this.addStrtegy.strategyName
          this.Data.Strategys.push(data)
        }
      }
      this.strategyTrigger = false
    },
    // 打开新增策略弹窗
    openStrategyW () {
      this.addStrtegy = {
        strategyType: 1,
        strategyItem: this.strategyList[0].id,
        strategyName: ''
      }
    },
    // 绑定选择区域事件
    bindChooseAreaEvent () {
      setTimeout(() => {
        this.$refs.partArea.$el.onclick = () => {
          this.areaTrigger = true
        }
      }, 1000);
    },
    // 筛选星期
    filterWeek (index) {
      this.weekIndx = index
      const week = ['全部', '周一', '周二', '周三', '周四', '周五', '周六', '周日']
      this.curWeekDay = week[index]
    },
    // 发送数据
    addData () {
      console.log(this.strategyList)
      const data = {
        AdId: this.formData.adid,
        PutOnId: this.formData.putonid,
        AdTaskName: this.formData.planName,
        AdrLink: this.formData.putonLink,
        PutOnTypeId: this.formData.putonType,
        LabelIds: this.formData.adTag,
        OrderType: this.formData.exposureSort,
        OrderNum: parseInt(this.formData.orderNum),
        LimitAmount: parseInt(this.formData.planDayBudget),
        AwardType: this.formData.adType,
        ValidityDateStart: this.formData.putonDate[0],
        ValidityDateEnd: this.formData.putonDate[1],
        ChargeType: this.formData.accountType,
        JSFlag: this.formData.linkJs ? 1 : 0,
        IsComplete: this.formData.openS ? 1 : 0,
        GraphicText: this.getUEContent(),
        ImportantStatement: this.formData.ImportantStatement,
        Materials: this.materials,
        Strategys: this.Data.Strategys
      }

      // 检查基本信息有没有填写
      if (data.AdId === 0 || data.AdTaskName === '' || data.AdrLink === '' || data.PutOnTypeId === '' || data.LabelIds === '' || data.ValidityDateStart === '' || data.ValidityDateEnd === '' || data.ChargeType === '') {
        this.$message.error('基本信息填写不完整，无法保存')
        return
      }
      // 检查数字格式（带小数点）
      if (!/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(data.LimitAmount) && data.LimitAmount != '') {
        this.$message.error('计划日预算输入格式不正确')
        return
      }
      // 检查数字格式（不带小数点）
      if (!/(^\d+$)/.test(data.OrderNum) && data.OrderNum != '') {
        this.$message.error('手动排序值输入格式不正确')
        return
      }
      // 检查素材状态时候满足要求
      if (data.Materials.length === 0) {
        this.$message.error('尚未添加素材')
        return
      }
      let flag = false
      data.Materials.forEach((item, index) => {
        if (item.openS) {
          flag = true
        }
      })
      if (!flag) {
        this.$message.error('素材至少开启一张')
        return
      }
      // 检查策略信息有没有填写完成
      let flag2 = false
      data.Strategys.forEach((item, index) => {
        if (item.OperatingSystem == ',,' || item.AccessPrice === '') {
          flag2 = true
        } else {
          item.AccessPrice = Number(item.AccessPrice)
          item.LimitAmount = Number(item.LimitAmount)
          if(typeof item.HourLimits === 'string') {
            item.HourLimits = JSON.parse(item.HourLimits)
          }
          item.HourLimits.forEach((hItem, hIndex) => {
            hItem.forEach((iItem, iIndex) => {
              iItem.LimitQty = Number(iItem.LimitQty)
            })
          })
          if (typeof item.HourLimits != 'string') {
            item.HourLimits = JSON.stringify(item.HourLimits)
          }
          if (typeof item.SourceLimits != 'string') {
            item.SourceLimits = JSON.stringify(item.SourceLimits)
          }
          // item.SourceLimits = JSON.stringify(item.SourceLimits)
        }
      })
      if (flag2) {
        this.$message.error('策略数据填写不完整，无法保存')
        return
      }
      // 重组时间
      if (data.ValidityDateStart && data.ValidityDateEnd && typeof data.ValidityDateStart != "string") {
        const year1 = data.ValidityDateStart.getFullYear()
        const month1 = (data.ValidityDateStart.getMonth() + 1) >= 10 ? (data.ValidityDateStart.getMonth() + 1) : '0' + (data.ValidityDateStart.getMonth() + 1)
        const day1 = data.ValidityDateStart.getDate() >= 10 ? data.ValidityDateStart.getDate() : '0' + data.ValidityDateStart.getDate()
        const year2 = data.ValidityDateEnd.getFullYear()
        const month2 = (data.ValidityDateEnd.getMonth() + 1) >= 10 ? (data.ValidityDateEnd.getMonth() + 1) : '0' + (data.ValidityDateEnd.getMonth() + 1)
        const day2 = data.ValidityDateEnd.getDate() >= 10 ? data.ValidityDateEnd.getDate() : '0' + data.ValidityDateEnd.getDate()
        data.ValidityDateStart = year1 + '-' + month1 + '-' + day1
        data.ValidityDateEnd = year2 + '-' + month2 + '-' + day2
      }
      // 对比时间段有没有冲突
      if (this.checkLimitTime()) {
        this.$message.error('限流时间段存在冲突，请修改后保存')
        return
      }
      console.log(data)
      // 发送请求
      this.$http.post('/iad_puton/SavePutOn', qs.stringify(data)).then(res => {
        console.log(res)
        if (res.status == 1) {
          location.href = "/iad_puton/list"
        }
      })

    }
  },
  watch: {
    strategyActive: {
      handler (val, oldVal) {
        const index = this.strategyOrder
        this.Data.Strategys[index] = JSON.parse(JSON.stringify(val))
        this.Data.Strategys[index].IsComplete = this.Data.Strategys[index].openS ? 1 : 0
        // this.Data.Strategys[index].HourLimits = []
        if (this.Data.Strategys[index].OS.indexOf('其他') > -1) {
          this.Data.Strategys[index].OS.splice(this.Data.Strategys[index].OS.indexOf('其他'), 1)
          this.Data.Strategys[index].OS.push('h5')
        }
        this.Data.Strategys[index].OperatingSystem = ',' + this.Data.Strategys[index].OS.join(',') + ','
      },
      deep: true
    },
    Data: {
      handler (val, oldVal) {
        this.strategyList = []
        this.Data.Strategys.forEach((item, index) => {
          const l = this.strategyList.length
          this.strategyList.push({
            name: item.AdTaskName,
            id: l,
            isActive: false
          })
        })
        this.strategyList[this.strategyOrder].isActive = true
      },
      deep: true
    },
    materials: {
      handler (val, oldVal) {
        this.materialsMin = []
        this.materials.forEach((item, index) => {
          item.openS = item.OpenState === 0 ? false : true
          if (item.OpenState === 1) {
            this.materialsMin.push({
              img: item.BannerSrc,
              name: item.Name,
              id: item.MaterialId
            })
          }
        })
        const l = 5 - this.materialsMin.length
        for (var i = 0; i < l; i++) {
          this.materialsMin.push({
            img: 'http://static.adjuz.com/ImgUpload/plat/2018/06/01/b_img.png',
            name: '默认',
            id: i
          })
        }
      },
      deep: true
    }
  },
  components: {
    layout,
    crumbs,
    block,
    multiMateial,
    UE
  },
  created () {
    let aa = location.search
    // let aa = '?putOnId=0&adid=0&copyid=41768'
    let paramStr = aa.substr(1)
    let paramsArr = paramStr.split('&')
    let paramsData = {}
    for(var i = 0; i < paramsArr.length; i++){
      const wapper = paramsArr[i].split('=')
      const key = wapper[0]
      const value = wapper[1]
      if (value === 'undefined') {
        paramsData[key] = undefined
      } else {
        paramsData[key] = Number(value)
      }
    }
    if (paramsData.putOnId) {
      this.isEdit = true
    }

    if (paramsData.putOnId) {   // 有 putonId 就是编辑
      // 三个参数分别表示：投放id， 广告id， 是编辑（不是复制）
      this.getData(paramsData.putOnId, 0, 0)
      this.operateType = '编辑计划'
    } else {   // 没有 putonId   可能是新建或者复制
      if (paramsData.copyid) {  // 有copyid 是复制
        this.getData(paramsData.copyid, 0, 1)
        this.operateType = '复制计划'
      } else {   // 没有putonId和copyid，  就是添加
        this.getData(0, paramsData.adid, 0)
        this.operateType = '添加计划'
      }
    }

    this.getAdList()
    this.getPutonType()
  },
  mounted () {
    this.bindChooseAreaEvent()
  }
};
</script>

<style lang="scss" scoped>
@import "../../common/scss/color.scss";

.content-wrapper {
  font-size: 14px;
  .banxin {
    width: 1310px;
    margin: 0 auto;
  }
  .content-wrapper-body {
    padding: 0 20px;
    .page-title {
      font-weight: 400;
      color: $mainColor;
      text-align: center;
    }
    .form-group {
      padding: 12px 0;
      max-width: 1300px;
      .form-inline {
        & + .form-inline {
          margin-top: 12px;
        }
        display: flex;
        justify-content: space-around;
        line-height: 34px;
        .form-item {
          width: 366px;
          .label {
            display: inline-block;
            font-size: 14px;
            color: #333;
            padding-right: 4px;
            width: 87px;
            text-align: right;
          }
          .el-input__inner,
          .el-select,
          .el-autocomplete,
          .el-input {
            width: 266px;
            height: 34px;
          }
          .el-checkbox-group {
            width: 243px;
            display: inline-block;
          }
          .el-checkbox+.el-checkbox {
            margin-left: 17px;
          }
          .el-checkbox__label {
            padding-left: 6px;
          }
          .el-radio + .el-radio {
            margin-left: 8px;
          }
          .content-wrapper {
            height: 406px;
            &.strategy {
              width: 516px;
            }
            &.rich-text {
              width: 716px;
              .important-declare {
                width: 100%;
                margin-top: 10px;
                textarea {
                  padding: 8px 12px;
                  box-sizing: border-box;
                  font-size: 14px;
                  width: 100%;
                  border: 1px solid $borderColor;
                  border-radius: 4px;
                  height: 152px;
                }
              }
            }
          }
          &.require .label::before {
            content: "*";
            color: red;
          }
          &.money-item {
            position: relative;
            .money-icon {
              color: #666;
              width: 34px;
              text-align: center;
              height: 34px;
              border-left: 1px solid $borderColor;
              position: absolute;
              right: 0;
              top: 0;
              font-size: 18px;
            }
          }
        }
      }
    }
    .limit-config {
      border: 1px solid $borderColor;
      .el-button--small,
      .el-button--small.is-round {
        padding: 10px 10px;
      }
      .data-header {
        background-color: #f8f9fa;
        border-bottom: 1px solid $borderColor;
      }
      .data-body {
        height: 298px;
        overflow-y: auto;
      }
      .data-inline {
        display: flex;
        justify-content: space-around;
        height: 48px;
        line-height: 48px;
        .item1 {
          width: 429px;
          text-align: center;
          &.tHeader {
            position: relative;
            .btnWeek {
              display: inline-block;
              height: 48px;
              width: 80px;
              cursor: pointer;
              &:hover {
                color: $mainColor;
                .week-item {
                  color: #333;
                }
              }
            }
            .week-group {
              position: absolute;
              margin: auto;
              top: 48px;
              left: 0;
              right: 0;
              width: 66%;
              background-color: #fff;
              border: 1px solid $borderColor;
              display: flex;
              flex-wrap: wrap;
              box-shadow: 0 0 18px #ccc;
              padding: 4px 7px;
              .week-item {
                cursor: pointer;
                width: 70px;
                height: 34px;
                line-height: 34px;
                border-radius: 50%;
                &.active {
                  background-color: $mainColor;
                  color: #fff;
                }
              }
            }
          }
          .el-button.active {
            background-color: $mainColor;
            color: #fff;
          }
        }
        .item2 {
          width: 271px;
          text-align: center;
        }
        .item3 {
          width: 165px;
          text-align: center;
        }
        .item4 {
          width: 126px;
          text-align: center;
          &.skew {
            position: relative;
            right: 9px;
          }
        }
        .item5 {
          width: 61px;
          text-align: center;
          &.skew {
            position: relative;
            right: 15px;
          }
          i {
            font-size: 20px;
            cursor: pointer;
          }
        }
      }
    }
    .basic-info {
      width: 100%;
    }
    .stratergy-group {
      margin-top: 50px;
      position: relative;
      max-width: 1300px;
      .add-strategy {
        cursor: pointer;
        position: absolute;
        text-align: center;
        right: 34px;
        top: -32px;
        font-size: 16px;
        background-color: $mainColor;
        color: #fff;
        width: 104px;
        height: 32px;
        line-height: 32px;
      }
    }
    .ads-config {
      margin-top: 40px;
      margin-bottom: 30px;
      display: flex;
      width: 1270px;
      justify-content: space-between;
      .ads-config-item {
        width: 615px;
        height: 382px;
        border: 1px solid $borderColor;
        position: relative;
        .leftTopTag {
          position: absolute;
          width: 103px;
          height: 35px;
          text-align: center;
          line-height: 36px;
          color: #333;
          border: 1px solid $borderColor;
          border-bottom-color: transparent;
          background-color: #fff;
          border-radius: 6px 6px 0 0;
          left: -1px;
          top: -36px;
        }
        .search-part {
          width: 583px;
          padding: 16px;
          height: 35px;
          border-bottom: 1px solid $borderColor;
          .el-button {
            width: 96px;
            background-color: $mainColor;
          }
        }
        .list-part {
          .list-item {
            text-align: center;
            &.item1 {
              width: 102px;
            }
            &.item2 {
              width: 211px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            &.item3 {
              width: 126px;
            }
            &.item4 {
              width: 122px;
              &.skew {
                position: relative;
                right: 17px;
              }
              i {
                font-size: 20px;
                cursor: pointer;
              }
            }
          }
          .list-header {
            display: flex;
            justify-content: space-between;
            background-color: #f8f9fa;
            height: 39px;
            line-height: 39px;
            border-bottom: 1px solid $borderColor;
          }
          .list-body {
            height: 276px;
            overflow-y: auto;
            .list-tr {
              text-align: center;
              display: flex;
              justify-content: space-between;
              height: 39px;
              line-height: 39px;
              .item3 {
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
}
.footer {
  width: 263px;
  margin: 46px auto;
  .el-button {
    width: 122px;
    height: 44px;
  }
}
.info {
  border-radius: 10px;
  line-height: 20px;
  padding: 10px;
  margin: 10px;
  background-color: #ffffff;
}
.addStrategy {
  width: 1200px;
  margin: 0 auto;
  .el-dialog {
    width: 36%;
  }
}
.ads-sheild {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 2000;
  .ads-frame {
    position: fixed;
    margin: auto;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 700px;
    height: 580px;
    background-color: white;
    .frame-header {
      width: 100%;
      height: 45px;
      background-color: #5898d7;
      position: absolute;
      .search-box {
        width: 192px;
        height: 26px;
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        left: 420px;
        background-color: cyan;
        border-radius: 14px;
        .icon {
          position: absolute;
          top: 3px;
          left: 9px;
          color: #888;
          font-size: 18px;
        }
        .clear {
          position: absolute;
          top: 6px;
          right: 12px;
          color: #aaa;
        }
      }
      span {
        position: absolute;
        right: 20px;
        top: 14px;
        font-size: 18px;
        color: white;
        cursor: pointer;
      }
      h4 {
        line-height: 45px;
        margin: 0;
        color: white;
        text-align: center;
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
  #search-frame {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    border-radius: 14px;
    padding-left: 30px;
  }
  .ads-frame .frame-body {
    margin-top: 45px;
    height: 492px;
    padding: 16px 0 0 42px;
    ul {
      overflow: auto;
      height: 88%;
      li {
        float: left;
        margin-right: 29px;
        margin-bottom: 16px;
        &:nth-child(4n) {
          margin-right: 0;
        }
        .btn {
          padding: 0 10px;
          border: 1px solid #aaa;
          border-radius: 6px;
          cursor: pointer;
          width: 129px;
          height: 40px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &.selected {
            background-color: $mainColor;
            color: #fff;
          }
        }
      }
    }
  }
}
.ads-frame .frame-footer {
  width: 100%;
  height: 75px;
  position: absolute;
  bottom: 0;
  .btn-box {
    margin: 12px auto;
    width: 240px;
    display: flex;
    justify-content: space-between;
    .el-button {
      width: 110px;
    }
  }
}

.adsW-enter,
.adsW-leave-to {
  opacity: 0;
}
.adsW-enter-active,
.adsW-leave-active {
  transition: all 0.4s ease;
}
.weekGroup-enter,
.weekGroup-leave-to {
  opacity: 0;
}
.weekGroup-enter-active,
.weekGroup-leave-active {
  transition: all 0.4s ease;
}

</style>



// WEBPACK FOOTER //
// src/components/edit-plan/edit-plan.vue